import {AbstractControl} from '@angular/forms';

export class PasswordValidation {

  static MatchPassword(AC: AbstractControl) {
    const newPassword = AC.get('newPassword').value; // to get value in input tag
    const confirmPassword = AC.get('confirmPassword').value; // to get value in input tag
    if (newPassword !== confirmPassword) {
      console.log('false');
      AC.get('confirmPassword').setErrors({MatchPassword: true});
    } else {
      console.log('true');
      return null;
    }
  }
  static NotMatchPassword(AC: AbstractControl) {
    const oldPassword = AC.get('old').value; // to get value in input tag
    const newPassword = AC.get('password').value; // to get value in input tag
    if (oldPassword == newPassword) {
      console.log('false');
      AC.get('password').setErrors({NotMatchPassword: true});
    } else {
      console.log('true');
      return null;
    }
  }
}
